// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__J8i5_","buttons":"PendingPaymentAlert_buttons__3qZUW"};